import React from 'react'
import AppStoreIcon from './app-store.svg'
import styles from './styles.css'
import config from '#src/config'

const IOSDownload: React.SFC<{}> = () => (
  <div className={styles.container}>
    <div className={styles.header}>Connect with your expert on our free app</div>
    <AppStoreIcon onClick={() => (window.location.href = config.get('adjust.footer'))} />
  </div>
)

export default IOSDownload
